var map = {
	"./it_extensiondegarantia.svg": "fcba",
	"./it_insurama.svg": "cea8",
	"./it_seguromovil.svg": "5905",
	"./it_seguromultidispositivo.svg": "ddb4",
	"./it_seguropatinete.svg": "3af0",
	"./it_seguroportatil.svg": "5e59",
	"./mx_insurama.svg": "1154",
	"./mx_seguromovil.svg": "72c1",
	"./mx_seguromultidispositivo.svg": "4fd1",
	"./mx_seguroportatil.svg": "390c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4a4";